import * as React from 'react'
import * as domain from '@packages/domain'
import styled, { css } from 'styled-components'
import { O, pipe } from '@packages/prelude'
import { react, Screen } from '../commons'

interface PostImageProps {
  image: domain.Image.Type
  uri?: string
}

const Img = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`
const Container = styled.a`
  display: block;
  position: relative;

  padding-bottom: 58%;

  width: 100%;
  min-height: 100%;
  ${Screen.is('xs')(css`
    height: auto;
    aspect-ratio: 1.5;
    margin-bottom: $grid-gutter-width;
  `)}
`

export const PostImage: React.VFC<React.PropsWithChildren<PostImageProps>> = ({ image, uri, children }) => {
  return pipe(
    uri,
    O.fromNullable,
    O.fold(
      () => react.wrap(() => <Container as="div" />)(<Img src={image.url}>{children}</Img>),
      link => (
        <Container href={link}>
          <Img src={image.url} />
          {children}
        </Container>
      )
    )
  )
}
